import { ITextStyles, FontWeights } from "@fluentui/react";

const boldStyle: Partial<ITextStyles> = {
  root: { fontWeight: FontWeights.semibold },
};

export { boldStyle };
